import { create } from 'zustand'

export type TPayloadCardModule = {
  chartId?: number
  chartType?: string
  chartListType?: string
  chartTitle?: string
}

type TCardMenuStore = {
  current?: string
  payload?: TPayloadCardModule
  clear(): void
  showModule(module: string, payload?: TPayloadCardModule): void
}

export const useCardMenuStore = create<TCardMenuStore>((set) => ({
  current: undefined,
  clear: () => set({ current: undefined, payload: undefined }),
  showModule: (module: string, payload) => set({ current: module, payload }),
  payload: undefined,
}))
